import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import {TransitionProps} from '@mui/material/transitions'
import Form from './Form'
import {useTranslation} from 'react-i18next'
import iMedia from '../../../interface/iMedia'
import MainBtn from '../../customTable/MainBtn'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />
})

export default function Create({
  rows,
  setRows,
  setAdded,
  num,
  setNum,
}: {
  rows: iMedia[] | never[]
  setRows: React.Dispatch<React.SetStateAction<iMedia[] | never[]>>
  setAdded: React.Dispatch<React.SetStateAction<boolean>>
  setNum?: any
  num?: any
}) {
  const [open, setOpen] = React.useState(false)
  const {t} = useTranslation()

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    if (!iloading) {
      setOpen(false)
    }
  }
  const [iloading, setIsLoading] = React.useState(false)

  return (
    <div>
      <MainBtn
        backageKey='MEDIA_NUM'
        num={num}
        width='auto'
        handelSubmit={handleClickOpen}
        text='create'
      />

      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby='alert-dialog-slide-description'
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: 'var(--bs-body-bg)', // تعديلاتك الخاصة هنا
          },
          '& .MuiDialog-paperWidthSm': {
            maxWidth: '600px', // تعديلاتك الخاصة هنا
          },
        }}
      >
        {open && (
          <Form
            iloading={iloading}
            setIsLoading={setIsLoading}
            setNum={setNum}
            setAdded={setAdded}
            open={open}
            rows={rows}
            setRows={setRows}
            setOpen={setOpen}
          />
        )}
      </Dialog>
    </div>
  )
}
